import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { label, success, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	amountText: {
		color: success,
		fontSize: 18,
	},
	clickableRow: {
		cursor: 'pointer',
		':hover': {
			background: THEME.colors.background.main,
		},
		':focus-visible': {
			outline: `2px solid ${THEME.colors.primary.main}`,
			outlineOffset: -2,
		},
	},
	contentSection: {
		padding: '12px 20px',
	},
	contentHeader: {
		display: 'flex',
		gap: 8,
	},
	donationsIcon: {
		fill: white,
	},
	contentListTitle: {
		marginTop: 8,
		marginBottom: 24,
	},
	contentAddButton: {
		marginBottom: 10,
		marginLeft: 'auto',
	},
	item: {
		fill: white,
	},
	tableOverrides: {
		marginTop: 16,
		padding: 8,
	},
	emptyText: {
		color: label,
		fontSize: 14,
	},
	rollUpSummary: {
		color: label,
		fontSize: 14,
		marginBottom: 8,
	},
	donorName: {
		fontSize: 14,
	},
	detailsCell: {
		paddingTop: 0,
		paddingBottom: 8,
	},
});
